import $ from 'jquery';

export const PXGame = (function () {
	'use strict';

	var $game, $gameContainer, $gameQuestions, $gameDots, $gameResetButton, currentSlide;

	function init() {
		$game = $('.game');
		$gameContainer = $game.find('.game__container');
		$gameQuestions = $game.find('.game-question');
		$gameDots = $game.find('.game__dots');
		$gameResetButton = $game.find('.game__completed-redo button');

		currentSlide = 0;
		$gameQuestions.eq(currentSlide).addClass('active');

		gameInit(currentSlide);
		gameQuestions();
		gameReset($gameResetButton);
	}

	function gameInit() {
		var totalWidth = parseFloat($gameContainer.outerWidth() * $gameQuestions.length);
		$gameContainer.css('width', totalWidth + 'px');
		$(window).on('resize', function () {
			totalWidth = $game.innerWidth() * $gameQuestions.length;
			$gameContainer.css('width', totalWidth + 'px');
			// console.log($game.outerWidth(), $gameQuestions.length, totalWidth);
		});

		for (var idx = 0; idx < $gameQuestions.length; idx++) {
			$gameDots.append('<div class="game__dot" data-slide="' + idx + '"></div>');
		}
	}

	function gameQuestions() {
		$gameQuestions.each(function () {
			var $question = $(this);
			var $default_message_box = $question.find('.game-question__progress-message > div');
			var $plural = $question.attr('data-answers') > 1 ? 's' : '';
			$default_message_box.text('Select ' + $question.attr('data-answers'));

			$question.children('.game-question__answer').on('click', function (e) {
				e.preventDefault();
				var $this = $(this);
				var $answered = $this.parent().attr('data-answered');
				var $answers = $this.parent().attr('data-answers');
				var $correct = $this.data('correct');

				if ($correct == 1 && !$this.hasClass('game-question__answer--correct')) {
					$answered++;
					$this.parent().attr('data-answered', $answered);
					$this.children('.game-question__answer-details').children('span').text($answered);
					$this.addClass('game-question__answer--correct');
					$question.find('.game-question__progress-correct:nth-child(' + $answered + ')').addClass('answered');
					renderMessage($question, 'correct', $this.closest('.game-question').hasClass('game-question--h'));
				} else if (!$correct) {
					$this.addClass('game-question__answer--incorrect');
					renderMessage($question, 'wrong', $this.closest('.game-question').hasClass('game-question--h'));
					setTimeout(function () {
						$this.removeClass('game-question__answer--incorrect');
					}, 3000);
				}

				if ($answered == $answers) {
					changeSlide($question);
				}
			});
		});
	}

	function renderMessage(question, type, hardHitting) {
		if (question.length < 1 || typeof type !== 'string') {
			return;
		}
		let $msg_box = question.find('.game-question__progress-message > div');
		let $correct_msgs = $msg_box.data('correct-msgs');
		let $wrong_msgs = $msg_box.data('wrong-msgs');
		let hard_hitting_correct_answers = [];
		let easy_correct_answers = [];
		let hard_hitting_wrong_answers = [];
		let easy_wrong_answers = [];
		$.each($correct_msgs, function (key, value) {
			// if questions are hard hitting, seperate into arrays
			value.correct_hard_hitting_answer ? hard_hitting_correct_answers.push(value) : easy_correct_answers.push(value);
		});
		$.each($wrong_msgs, function (key, value) {
			// if questions are hard hitting, seperate into arrays
			value.wrong_hard_hitting_answer ? hard_hitting_wrong_answers.push(value) : easy_wrong_answers.push(value);
		});
		// console.log('work', hard_hitting_wrong_answers, easy_wrong_answers);
		let random_hard_correct_number = Math.floor(Math.random() * hard_hitting_correct_answers.length);
		let random_easy_correct_number = Math.floor(Math.random() * easy_correct_answers.length);
		let random_hard_wrong_number = Math.floor(Math.random() * hard_hitting_wrong_answers.length);
		let random_easy_wrong_number = Math.floor(Math.random() * easy_wrong_answers.length);

		if (type == 'correct') {
			if (hardHitting) {
				$.each(hard_hitting_correct_answers, function (key, value) {
					if (key === random_hard_correct_number) {
						$msg_box.text(value.correct_message);
					}
				});
			} else {
				$.each(easy_correct_answers, function (key, value) {
					if (key === random_easy_correct_number) {
						$msg_box.text(value.correct_message);
					}
				});
			}
		}
		if (type == 'wrong') {
			if (hardHitting) {
				// console.log('inside hard questions?');
				$.each(hard_hitting_wrong_answers, function (key, value) {
					if (key === random_hard_wrong_number) {
						$msg_box.text(value.wrong_message);
					}
				});
			} else {
				$.each(easy_wrong_answers, function (key, value) {
					// console.log('here', key, value );
					if (key === random_easy_wrong_number) {
						$msg_box.text(value.wrong_message);
					}
				});
			}
		}
	}

	function changeSlide(question) {
		$game.css('pointer-events', 'none');
		console.log('start chnage');
		$gameDots.children('.game__dot').eq(currentSlide).addClass('completed');
		currentSlide = currentSlide += 1;
		var shiftX = $game.innerWidth() * currentSlide + 'px';

		setTimeout(function () {
			if ($gameQuestions.length == currentSlide) {
				$game.find('.game__completed').addClass('active');
				$game.css('pointer-events', 'auto');
				return;
			}
			question.removeClass('active');
			question.next().addClass('active');
			$gameContainer.css('transform', 'translateX(-' + shiftX + ')');
			$game.css('pointer-events', 'auto');
		}, 2000);
	}

	function gameReset(button) {
		button.click(function () {
			location.reload();
			// currentSlide = 0;
			// $game.find(".game__completed").removeClass("active");
			// $gameQuestions.attr("data-answered", 0);
			// $gameQuestions
			//      .eq(currentSlide)
			//      .addClass("active")
			//      .siblings()
			//      .removeClass("active");
			// $gameQuestions
			//      .find(".game-question__answer")
			//      .removeClass("game-question__answer--correct");
			// $gameDots.children(".game__dot").removeClass("completed");
			// $gameContainer.css("transform", "translateX(0)");
			// $gameQuestions
			//      .find(".game-question__progress-correct")
			//      .removeClass("answered");
			// $gameQuestions
			//      .find(".game-question__progress-message > div")
			//      .text("");
		});
	}

	return {
		init: init,
	};
})();
